module.exports = __webpack_public_path__ + "img/20191209_111729-1.95754d39.jpg";